import { routerService } from "cruzo";
import { routerUrlBucket } from "site/urls";

export function buildRulesListHref(): string {
  return routerUrlBucket.buildUrl("rules");
}

export function buildRuleEditorHref(ruleId: string, returnTo?: string | null): string {
  const query = new URLSearchParams();
  if (returnTo) {
    query.set("return", returnTo);
  }
  return routerUrlBucket.buildUrl("rule_edit", { ruleId }, query);
}

export function readRuleEditorReturnParam(): string | null {
  const raw = new URLSearchParams(routerService.search$.actual).get("return");
  if (!raw) {
    return null;
  }
  return raw;
}

export function pushRuleEditorHref(ruleId: string, returnTo?: string | null) {
  routerService.pushHistory(buildRuleEditorHref(ruleId, returnTo));
}
